
import React from "react";
import "./DetailPageModalFooter.scss";
import {assetUrl} from "../../serviceApi";

const InfoIcon = assetUrl+"images/icon_info.svg";
const WhiteArrowRight = assetUrl+"images/arrow-right-white-sm.svg";
const errorInfo = assetUrl+"images/error_info_2x.png";


function DetailPageModalFooter(props){

    const {limit_order_price,stock_data,order_mode,submit,buttonText,quantity,walletData,selected_action} = props;
    return(
        <div className={"total-footer d-flex align-items-center justify-content-between"}>
	        {
		        selected_action === "buy" && order_mode === "Market_Order" &&
		        (stock_data.price * quantity > walletData.balance) &&
		        <div className={"error-box d-flex justify-content-center"}>
			        <img src={errorInfo} alt={"alt"} className={"error-info-icon"}/>
			        <p className={'error-message mb-0'}>Insufficient Balance available in your wallet.</p>
		        </div>

	        }
	        {
		        selected_action === "buy" &&   order_mode !== "Market_Order" &&
		        (limit_order_price * quantity > walletData.balance) &&  (stock_data.price * quantity > walletData.balance) &&
		        <div className={"error-box d-flex justify-content-center"}>
			        <img src={errorInfo} alt={"alt"} className={"error-info-icon"}/>
			        <p className={'error-message mb-0'}>Insufficient Balance available in your wallet.</p>
		        </div>

	        }
            <div>
                <div className={"d-flex align-items-center"}>
                    <p className={"estimate-total-content"}>EST. TOTAL</p>
                    <img src={InfoIcon} alt={"InfoIcon"} style={{marginBottom:"12px"}}/>
                </div>
                {

                    order_mode === "Limit_Order" ?
                        <p className={"estimate-total"}>₹ {(limit_order_price * quantity).toFixed(2)}</p>
                        :
                        <p className={"estimate-total"}>₹ {(stock_data.price * quantity).toFixed(2)}</p>

                }

            </div>
            <button type={"button"} className={"btn submit-btn"} onClick={submit}>
                {buttonText}
                <img src={WhiteArrowRight} alt={"WhiteArrowRight"} style={{marginLeft:"8px"}}/>
            </button>

        </div>
    );
}

export default DetailPageModalFooter;
